import React, { useMemo, useRef, useState } from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import { debounce } from 'lodash';
import { Select, Spin } from 'antd';

export const svgIcon = (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.93945 0.32959L4.7197 3.54934L1.49995 0.32959L0.439453 1.39009L4.7197 5.67034L8.99995 1.39009L7.93945 0.32959Z"
      fill="#828D9E"
    />
  </svg>
);

const AutoSelectComp = (props: any) => {
  const { fetchOptions, debounceTimeout = 800, suffixIcon, ...rest } = props;
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = useRef(0);
  // const [suffixIcon, setSuffixIcon] = useState<ReactNode>(
  //   <Icon component={() => svgIcon} />
  // );

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value: any) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions: any) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(newOptions);
        setFetching(false);
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  return (
    <Select
      className={`${props.className ?? ''} zeiss-reset-select`}
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      showSearch
      suffixIcon={suffixIcon ?? <Icon component={() => svgIcon} />}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={options}
      {...rest}
    />
  );
};

export default AutoSelectComp;
